<template>
  <div class="contact-us-bar-component"
       :style="bgStyle"
  >
    <div class="contact-us-bar-item"
         :style="colorStyle"
         @click="handleWeChatClick"
         v-ym-report:ANNIVERSARY_2021_WECHAT_CLICK=""
    >
      微信咨询
    </div>
    <a class="contact-us-bar-item"
       href="tel:4008093885"
       :style="colorStyle"
       @click="handleTelClick"
       v-ym-report:ANNIVERSARY_2021_TELEPHONE_CLICK=""
    >
      电话咨询
    </a>
  </div>
</template>

<script>
  import { before, decorator } from 'ym-reporter-vue';

  export default {
    name: 'ContactUsBar',
    props: {
      topColor: {
        type: String,
        required: true,
      },
      bottomColor: {
        type: String,
        required: true,
      },
      textColor: {
        type: String,
        required: true,
      },
      wechatEventName: {
        type: String,
        default: '',
      },
      telEventName: {
        type: String,
        default: '',
      },
    },
    computed: {
      bgStyle() {
        const result = {};
        result.background = `linear-gradient(0deg, ${this.bottomColor} 0%, ${this.topColor} 100%)`;
        result.color = `${this.textColor}`;
        return result;
      },
      colorStyle() {
        return `color: ${this.textColor}`;
      },
    },
    methods: {
      @decorator(before(function () {
        if (this.wechatEventName === '') return;
        this.$reporter.report(this.wechatEventName);
      }))
      handleWeChatClick() {
        this.$emit('wechat');
      },
      @decorator(before(function () {
        if (this.telEventName === '') return;
        this.$reporter.report(this.telEventName);
      }))
      handleTelClick() {
        this.$emit('tel');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .contact-us-bar {
    &-component {
      width: 100%;
      height: 140px;
      display: flex;
    }
    &-item {
      flex: 1;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      font-weight: @font-weight-bold;
      &:not(:last-child) {
        &::after {
          position: absolute;
          right: 0;
          top: 23px;
          width: 2px;
          height: 96px;
          content: '';
          background: currentColor;
        }
      }
    }
  }
</style>
